import { createBuilderModule } from '../../builder';
import { SectionName } from '../../observability/tracking/events';
import { withTracking } from '../../observability';
import { JobBoard } from './JobBoard';

export default createBuilderModule(
  withTracking(JobBoard, {
    as: 'section',
    sectionName: SectionName.JobBoard,
  }),
  {
    name: 'JobBoard',
    image: 'https://cdn.zappy.app/02334b8ec9c195061646f95f621e0d9c.png',
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'description',
        type: 'richText',
      },
    ],
  },
);
